import React, { useState } from "react";
import styles from "./PriceRange.module.css";
import { Box, Slider } from "@mui/material";

const PriceRange = ({ min, max, value, onValueChange }) => {
  const [localSliderValue, setLocalSliderValue] = useState(value || [min, max]);

  // Handle real-time slider updates locally
  const handleLocalSliderChange = (event, newValue) => {
    setLocalSliderValue(newValue);
  };

  // Commit changes to the parent once the user stops interacting with the slider
  const handleSliderChangeCommitted = (event, newValue) => {
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  const handleMinInputChange = (e) => {
    const newMin = Math.min(
      parseInt(e.target.value, 10) || min,
      localSliderValue[1],
    );
    setLocalSliderValue([newMin, localSliderValue[1]]);
    onValueChange([newMin, localSliderValue[1]]);
  };

  const handleMaxInputChange = (e) => {
    const newMax = Math.max(
      parseInt(e.target.value, 10) || max,
      localSliderValue[0],
    );
    setLocalSliderValue([localSliderValue[0], newMax]);
    onValueChange([localSliderValue[0], newMax]);
  };

  return (
    <div className={styles.productsSidebarAccordionContainer}>
      <Box className={styles.rangeBox}>
        <Slider
          value={localSliderValue}
          onChange={handleLocalSliderChange} // Real-time updates
          onChangeCommitted={handleSliderChangeCommitted} // Final commit
          min={min}
          max={max}
          valueLabelDisplay="on"
          style={{ color: "#101728" }}
          className={styles.productsSidebarRange}
        />
        <div className={styles.productsSidebarRanges}>
          <input
            type="number"
            className={styles.productsSidebarRangeInput}
            placeholder={`Min ${min}`}
            value={localSliderValue[0]}
            onChange={handleMinInputChange}
          />
          <div> - </div>
          <input
            type="number"
            className={styles.productsSidebarRangeInput}
            placeholder={`Max ${max}`}
            value={localSliderValue[1]}
            onChange={handleMaxInputChange}
          />
        </div>
      </Box>
    </div>
  );
};

export default PriceRange;
